import { Modal } from 'react-bootstrap-5';
import React, { useState } from 'react';
import EditModal from './edit_modal';
import { BrokerError, BrokerPanel, deleteRecord, modifyRecordArray, getChildCompanyUrlSuffix } from '../shared';
import Button from 'shared/button';

export default function Departments(props: DepartmentsProps) {
  const [departments, setDepartments] = useState<Department[]>(props.departments);
  const [modalObject, setModalObject] = useState<{ isOpen: boolean; id: string | number }>({ isOpen: false, id: '' });
  const [error, setError] = useState<string>('');

  const openModal = (id: string | number) => setModalObject({ isOpen: true, id });
  const closeModal = () => setModalObject({ isOpen: false, id: '' });
  const departmentToEdit = modalObject.id === ''
    ? null
    : departments.find(department => department.id === modalObject.id);

  const handleFormSubmit = (newDepartment: Department) => {
    modifyRecordArray(newDepartment, setDepartments, departments, 'name', modalObject, closeModal);
  };

  const deleteDepartment = ({ name, id }: { name: string; id: number }) => {
    const urlSuffix = getChildCompanyUrlSuffix();
    deleteRecord(id, name, '/company_departments', 'Department', setDepartments, setError, urlSuffix);
  };

  const addNewDepartment = () => openModal('');

  return (
    <React.Fragment>
      <Modal
        centered
        show={modalObject.isOpen}
        onHide={closeModal}
      >
        <EditModal
          id={modalObject.id}
          isRole={departmentToEdit?.isRole}
          key={`${modalObject.isOpen}-${modalObject.id}`}
          name={departmentToEdit?.name}
          onCloseModal={closeModal}
          onSuccessfulFormSubmit={handleFormSubmit}
        />
      </Modal>
      <div className="d-flex justify-content-between mb-3 mt-5 align-items-center top-buffer-xl">
        <h5 className="m-0">Departments & Roles</h5>
        <Button.Primary onClick={addNewDepartment}>Add Department or Role</Button.Primary>
      </div>

      <BrokerError error={error}/>
      <BrokerPanel
        cantModifyMessage=" " // Empty string to hide the message for non-modifiable records
        deleteRecord={deleteDepartment}
        firstColumnIdentifier="name"
        openModal={openModal}
        recordName="Department"
        records={departments}
        secondColumnIdentifier=""
        onClick={addNewDepartment}
      />

    </React.Fragment>
  );
}

export interface Department {
  canModify: boolean;
  id: number;
  isRole: boolean;
  name: string;
}

interface DepartmentsProps {
  departments: Department[];
}
